import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestExpenses } from "../../entity/EntityRequestExpenses";

export class DtoRequestExpensessPutReq extends EntityRequestExpenses {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_request_expenses_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
